import { render, staticRenderFns } from "./Deadline.vue?vue&type=template&id=1046f936&scoped=true&"
import script from "./Deadline.vue?vue&type=script&lang=js&"
export * from "./Deadline.vue?vue&type=script&lang=js&"
import style0 from "./Deadline.vue?vue&type=style&index=0&id=1046f936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1046f936",
  null
  
)

export default component.exports